import type { RfqRouteName } from '@/shared/common/types/rfqRoutes.type';

/** Query key en `/multi-transaction` cuando el flujo se abre desde Mesa de dinero. */
export const MULTI_TRANSACTION_RFQ_QUERY_PARAM = 'flow';

/** Valor del query `flow` que identifica el multienvío RFQ (`?flow=rfq`). */
export const MULTI_TRANSACTION_RFQ_QUERY_VALUE = 'rfq';

export const RFQ_ROUTE_NAMES = {
  HUB: 'rfq',
  EXCHANGE: 'rfq-exchange',
  SEND: 'rfq-send',
} as const;

export const RFQ_ROUTE_PATHS = {
  [RFQ_ROUTE_NAMES.HUB]: '/rfq',
  [RFQ_ROUTE_NAMES.EXCHANGE]: '/rfq/exchange',
  [RFQ_ROUTE_NAMES.SEND]: '/rfq/send',
} as const satisfies Record<RfqRouteName, string>;
